export enum FeatureFlag {
  MARKETING_CONTENT = 'marketing-content',
}
